import { Link } from 'react-router';
import sc from 'web/components/styled';
import link from './link.css';

const LinkStyled = sc(Link)(link);
LinkStyled.displayName = 'LinkStyled';

export default LinkStyled;
